import React, { useState } from 'react';

const FormSelect = ({
  label,
  errors,
  onChange,
  name,
  value,
  options = [],
  className = '',
  ...rest
}) => {
  const [focused, setFocused] = useState(false);
  
  const handleFocus = () => setFocused(true);
  const handleBlur = () => setFocused(value ? true : false);

  return (
    <div className="tw-mb-4 tw-relative">
      <div className={`tw-relative tw-mb-1 ${(focused || value) ? 'tw-border-gray-300' : ''}`}>
        <select
          className={`common-input ${className}`}
          name={name}
          value={value}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          {...rest}
        >
          <option value="">{focused ? label : ""}</option>
          {options.map((option) => (
            <option key={option.value || option} value={option.value || option}>
              {option.label || option}
            </option>
          ))}
        </select>
        <label 
          className={`tw-absolute tw-left-6 tw-pointer-events-none tw-text-gray-500 tw-font-normal tw-text-sm tw-transition-all tw-duration-200 
            ${(focused || value) 
              ? 'tw-top-0 tw-transform tw--translate-y-1/2 tw-left-3 tw-text-xs tw-bg-white tw-px-1 tw-text-primary' 
              : 'tw-top-1/2 tw-transform tw--translate-y-1/2'
            }`}
        >
          {label}
        </label>
      </div>
      {errors && (
        <span className="tw-text-red-600 tw-text-xs tw-mt-1 tw-block">{errors}</span>
      )}
    </div>
  );
};

export default FormSelect; 